export default {
  "content": "<path d=\"M20 13H4v-2h16v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};